import { FAILED_TRANSACTION_REPORT, FAILED_TRANSACTION_REPORT_SUCCESS, FAILED_TRANSACTION_REPORT_FAIL } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  failedTransactionReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const failedTransactionReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FAILED_TRANSACTION_REPORT: {
      return { ...state, isLoading: true };
    }
    case FAILED_TRANSACTION_REPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failedTransactionReport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FAILED_TRANSACTION_REPORT_FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default failedTransactionReportReducer;
